
<template>
  <div class="addLoss">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">损耗记录单</div>
        <div class="add-content">
          <div class="operation-btn">
              <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter" :disabled="enableTable||!edit">修改</el-button>
            <el-button size="small" class="save" @click="onSave" :disabled="!enableTable||!edit" :loading="isLoading">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="closeView">关闭</el-button>
          </div>
          <div class="custom-search-container" style="margin-top:25px;">
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>基地</span>
                <el-select v-model="order.fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange" :disabled="Boolean(orderId)||edit==false">
                  <el-option v-for="(item, index) in baseLists" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
              </div>
              <div class="custom-search-box-warpper">
                <span>日期</span>
                <el-date-picker size="small" :disabled="edit==false"  v-model="order.date" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                </el-date-picker>
              </div>
              
              <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input placeholder="请输入单据号" v-model="order.billsNo" size="small" disabled>
                </el-input>
              </div>
            </div>
            <div class="custom-search-box">
              <div class="custom-search-box-warpper" v-if="show">
                <span>流水号</span>
                <el-input placeholder="请输入流水号" v-model="order.numericalOrder" size="small" disabled>
                </el-input>
              </div>
              <div class="custom-search-box-warpper">
                <span>塘口</span>
                <el-select v-model="order.pond" filterable placeholder="请选择" size="small" @change="topPondChange" :disabled="Boolean(orderId) ||!edit">
                  <el-option v-for="(item, index) in topPondList" :key="index" :label="item.value" :value="item.key">
                  </el-option>
                </el-select>
                <span v-if="order.pond != ''">&nbsp;&nbsp;&nbsp;周期：{{this.order.fishBatch}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&edit">
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <th-ex>品种</th-ex>
            <th-ex>计量单位</th-ex>
            <th-ex>损耗重量(斤)</th-ex>
            <th-ex>损耗数量</th-ex>
            <th-ex>损耗原因</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <td-ex v-if="order.pond == ''" v-model="item.pond" :editable="item.pondEdit" :list="fishPondList" display="value" take="key" type='cmb' @selected="pondChange(item)"></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishId" :editable="item.fishEdit" type='cmb' :list="item.fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-if="order.pond != ''" v-model="item.fishId" :editable="item.fishEdit" type='cmb' :list="fishList" display="name" take="id" @selected="fishChange(item)"></td-ex>
              <td-ex v-model="item.unit" type='input'  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" ></td-ex>
              <td-ex v-model="item.weight" type='number'  number onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive :decimalLength="2"></td-ex>              
              <td-ex v-model="item.quantity" type='number'  number onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" positive ></td-ex>
              <td-ex v-model="item.remark" type='cmb'  :list="reasonList" display="name" take="name"></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex v-model="order.remark" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <td>--</td>
            <td>--</td>
            <td>{{total('weight')}}</td>
            <td>{{total('quantity')}}</td>
            <td>--</td>
            
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "@/common/MixIn.js";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
export default {
  mixins: [mixins],
  name: "addLoss",
  data() {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      show: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        date: new Date(),
        numericalOrder: 0,
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        billsNo: 0,
        remark: "",
        details: []
      },
      reasonList: [],
      baseLists: [],
      pondList: [],
      topPondList: [],
      fishList: [],
      enableTable: false,
      selectedRow: null,
      fishPondList: [],
      emptyRow: {
        pond: null,
        fishBatch: null,
        fishBatchId: null,
        fishId: null,
        fishName: "",
        unit: "",
        weight: 0,
        quantity: 0,
        remark: null,
        fishList: []
      },
      isLoading: false,
    };
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑损耗管理" : "查看损耗管理";
    } else {
      document.title = "增加损耗管理";
    }

    //基地
    let lossBase = storage.get("base");
    this.baseLists = await this.getBaseList(); //供应商
    let oldBase = this.baseLists.find(f => f.key == lossBase);
    if (!this.$route.query.id && oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
      // storage.set("lossBase", this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }

    this.reasonList = await this.getReasonList();
    this.initData();
  },
  methods: {
    ...mapActions(modules.fishLoss, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
      addFishLoss: "addFishLoss", //添加
      updateFishLoss: "updateFishLoss", //修改
      getEditFishLossData: "getEditFishLossData", //编辑--获取行数据
      delFishLossList: "delFishLossList" //删除
    }),
    ...mapActions(modules.dataDict, {
      getReasonList: "getReasonList" //损耗类型
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.fish, {
      getPondFishList: "getPondFishList" //塘口下的渔种
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch"
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber"
    }),
    ...mapActions(['delVisitedViews']),
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        //新增
        this.order.numericalOrder = await this.getSerialNumber();
        this.topPondList = await this.getFishPond(this.order.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
        this.initTable();
      } else {
        //修改
        let result = await this.getEditFishLossData(this.orderId);
        this.order.fishBaseId = result.fishBaseId;
        await this.baseChange(result.fishBaseId, true);
        // result.details.forEach(async item => {
        //   item.pondEdit = false;
        //   item.fishEdit = false;
        //   // item.fishList = await this.getPondFishList(item.fishBatchId);
        //   if (result.fishPondId === null) {
        //     item.fishList = [{ id: item.fishId, name: item.fishName }];
        //   } else {
        //     this.fishList = [{ id: item.fishId, name: item.fishName }];
        //   }

        //   item.fishId = item.fishId;
        //   item.fishName = item.fishName;
        // });
        let promises = result.details.map(item =>
          (async () => {
            item.pondEdit = false;
            item.fishEdit = false;
            if (result.fishPondId == null) {
              item.fishList = await this.getPondFishList(item.fishBatchId);
            } else {
              this.fishList = await this.getPondFishList(item.fishBatchId);
            }
            // item.fishId = item.fishId;
            // item.fishName = item.fishName;
          })()
        );
        await Promise.all(promises);
        this.order = result;
        this.orderId = result.id;
        this.topPondList = await this.getFishPond(result.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
        if (result.fishPondId === null) {
          this.order.pond = "";
        } else {
          this.order.pond = result.fishPondId;
          this.order.fishBatch = result.details[0].fishBatch;
          this.order.fishBatchId = result.details[0].fishBatchId;
        }
      }
      this.enableTable = true;
    },
    //改变基地数据
    async baseChange(e, notShowTip) {
      storage.set("base", e);
      let selectedBase = this.baseLists.find(f => f.key == e);
      if (!notShowTip && selectedBase && !selectedBase.notCleard) {
        this.$Alert.info({
          content: "当前选择的基地已经全部清塘，请选择其他基地",
          duration: 5000,
          status: "error"
        });
        // Message.error("当前选择的基地已经全部清塘，请选择其他基地");
      }
      this.getFishPond(e)
        .then(data => {
          this.fishPondList = data;
          if (this.fishPondList.length === 0) {
            this.$Alert.info({
              content: "当前选择的基地下无塘口，请先添加塘口信息",
              duration: 5000,
              status: "error"
            });
          }
        })
        .catch(() => {});

      this.enableTable = true;
      this.order.details.forEach(f => {
        f.pond = null;
        f.fishBatchId = null;
        f.fishBatch = null;
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.topPondList.unshift({
          key: "",
          value: "全部"
        });
        this.order.pond = "";
      }
    },
    async topPondChange(e) {
      if (!e) {
        //当什么都没有选中，则清理
        this.order.fishBatchId = "";
        this.order.fishBatch = null;
        return;
      }

      let result = await this.getPondUnclearedBatchNo(e);
      if (result) {
        this.order.fishBatchId = result.key;
        this.order.fishBatch = result.value;
        this.order.details.forEach(async (f, index) => {
          console.log(2, f);
          f.fishId = null;
          f.fishName = "";
          f.unit = null;
          let a = await this.getPondFishList(result.key);

          this.fishList = a;
          if (this.fishList.length == 0) {
            this.$Alert.info({
              content: "此塘口当前周期无进苗数据",
              duration: 5000,
              status: "error"
            });
          }
        });

        // this.order.details[0].fishList = await this.getPondFishList(result.key);
        // if (this.order.details[0].fishList.length == 0) {
        //   this.$Alert.info({
        //     content: "此塘口当前周期无进苗数据",
        //     duration: 5000,
        //     status: "error"
        //   });
        // }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
          this.order.fishBatchId = "";
          this.order.fishBatch = "";
        } catch (error) {
          this.order.pond = "";
        }
      }
    },
    //改变塘口--联动周期
    async pondChange(row) {
      if (!row.pond) {
        //当什么都没有选中，则清理
        row.fishBatchId = null;
        row.fishBatch = null;
        return;
      }
      let result = await this.getPondUnclearedBatchNo(row.pond);
      if (result) {
        row.fishBatchId = result.key;
        row.fishBatch = result.value;
        row.fishId = null;
        row.unit = null;
        row.fishName = null;
        row.fishList = await this.getPondFishList(result.key);
        if (row.fishList.length == 0) {
          this.$Alert.info({
            content: "此塘口当前周期无进苗数据",
            duration: 5000,
            status: "error"
          });
        }
        // Message.error("此塘口当前周期无进苗数据");
      } else {
        try {
          await MessageBox.confirm("此塘口已清塘，无法选择周期", "提示", {
            showConfirmButton: false,
            showCancelButton: false
          });
          row.fishBatchId = null;
          row.fishBatch = null;
        } catch (error) {
          row.pond = null;
        }
      }
    },

    async fishChange(row) {
      if (this.order.pond) {
        let item = this.fishList.find(f => f.id == row.fishId);
        if (item) {
          row.fishName = item.name;
          row.unit = item.unitName;
          row.fishCategoryId = item.categoryId;
        }
      } else {
        let item = row.fishList.find(f => f.id == row.fishId);
        if (item) {
          row.fishName = item.name;
          row.unit = item.unitName;
          row.fishCategoryId = item.categoryId;
        }
      }
    },
    //保存
    async onSave() {
      this.isLoading = true
      let err = null;
      if (!this.order.fishBaseId) err = "基地必须选择";
      if (!this.order.date) err = "日期必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      // let list = this.order.details.filter(f => {
      //   return f.pond !== "" && f.pond !== null;
      // });
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter(f => {
          return f.pond !== "" && f.pond !== null;
        });
      } else {
        list = this.order.details.filter(f => {
          return f.fishId !== "" && f.fishId !== null;
        });
        list.map(item => {
          item.pond = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
        });
      }
      let weightReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //重量
      let quantityReg = /^[0-9]{1,12}$/; //数量
      if (list.length == 0) err = "不能提交空表单";
      list.forEach(item => {
        if (item.quantity === 0) {
          err = "请输入数量";
        }
        if (!weightReg.test(item.weight)) {
          err = "重量范围至多12位正整数,2位小数";
        }
        if (!quantityReg.test(item.quantity)) {
          err = "数量只允许输入整数";
        }
        if (!item.pond) err = "塘口必须选择";
        if (!item.fishBatch || !item.fishBatchId) err = "周期必须选择";
        if (!item.fishId || !item.fishName) err = "品种必须选择";
        if (!item.remark) err = "损耗原因必须选择";
      });

      if (err) {
        Message.error(err);
        this.isLoading = false
        return;
      }
      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            await this.updateFishLoss({
              id: this.orderId,
              data: this.order
            });
            this.isLoading = false
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            let result = await this.addFishLoss(this.order);
            this.isLoading = false
            this.order.billsNo = result.number;
            this.order.numericalOrder = result.numericalOrder;
            this.orderId = result.id;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.isLoading = false
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(error.response.data);
        }
      });
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach(item => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete() {
      if (!this.orderId) {
        await this.$Alert.info({
          content: " 未找到订单Id,无法删除",
          duration: 5000,
          status: "error"
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delFishLossList(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    },
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/productionControl/lossManagement')
    }
  }
};
</script>
<style >
.addLoss .add-content-container,
.addLoss .add-titieMain {
  /* height: 190px; */
}
.addLoss .add-content-container .add-titieMain .add-content {
  /* height: 150px; */
}
.addLoss .custom-search-container {
  margin-top: 20px;
}
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}

.custom-search-container {
  margin-top: 70px;
}

.readonlys input {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
<style scoped>
/* .add-content {
  position: relative;
}
.custom-search-box {
  position: absolute;
  bottom: 20px;
} */
</style>
